import React from 'react';
import { ColorGroupField as ColorGroupFieldType } from '../../types/optionTypes';

interface ColorGroupFieldProps {
    field: ColorGroupFieldType;
    value: any;
    onChange: (value: any) => void;
}

export const ColorGroupField: React.FC<ColorGroupFieldProps> = ({ field, value, onChange }) => {
    const handleColorSelect = (optionValue: string) => {
        // Currently color group seems to be single select in JSON, but supporting multiple just in case
        onChange(optionValue);
    };

    const isSelected = (optionValue: string) => {
        return value === optionValue;
    };

    const layoutClass = field.layOut === 'inline' ? 'flex flex-wrap gap-3' : 'grid grid-cols-4 gap-3';
    const dispSize = field.disp_size || { width: '40', height: '40' };
    const width = `${dispSize.width}px`;
    const height = `${dispSize.height}px`;

    return (
        <div className="w-full">
            {field.label && (
                <label className="block text-sm font-medium text-gray-800 mb-3">
                    {field.label}
                    {field.required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}

            <div className={layoutClass}>
                {field.values.map((option) => {
                    const selected = isSelected(option.value);

                    return (
                        <div key={option.tempId} className="flex flex-col items-center gap-1">
                            <button
                                type="button"
                                onClick={() => handleColorSelect(option.value)}
                                style={{
                                    backgroundColor: option.color,
                                    width,
                                    height
                                }}
                                className={`
                                    rounded-full border-2 transition-all shadow-sm
                                    ${selected
                                        ? 'border-blue-600 ring-2 ring-blue-200 ring-offset-2'
                                        : 'border-gray-200 hover:border-gray-400'
                                    }
                                `}
                                title={option.label}
                            />

                            {!field.hideOptionLabel && (
                                <span className={`text-xs ${selected ? 'font-medium text-blue-600' : 'text-gray-600'}`}>
                                    {option.label}
                                </span>
                            )}
                        </div>
                    );
                })}
            </div>

            {field.description && (
                <div className="mt-2 text-xs text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: field.description }} />
            )}
        </div>
    );
};
